import Qs from 'qs';
import Vue from 'vue';
import {post, get, postForm} from './ajax';
import queue from './queue';

const baseApi = process.env.BASE_API;
/**
 * 获取参数的类型
 *
 * @param {any} data
 * @returns {string} 参数类型
 */
const type = (data) => {
  return Object.prototype.toString.call(data).replace(/(\[object |\])/g, '')
};

/**
 * 解析url参数
 *
 * @returns {object} localtion的query对象
 */
const query = () => {
  return Qs.parse(window.location.href.split('?')[1])
}

/**
 * call方法
 *
 * @param {Function} callMethod 调用的http包装方法
 * @param {String} url 调用接口
 * @param {Object} formData 需要发送参数
 * @param {Object} config 配置
 * @returns {Promise} axios请求
 */
const call = (callMethod, url, formData, config) => {
  return new Promise((resolve, reject)=>{
    document.body.classList.toggle('onload');
    callMethod(url, formData, config).then(({code, message, data})=>{
      if(code !== 200){
        if (code == 401){
          cookie.removeItem(Const.tokenName);
        }
        reject(message);
        return;
      }
      resolve(data);
    })
    .catch(tip=>{
      reject(tip);
    })
    .then(()=>{
      setTimeout(()=>{
        document.body.classList.toggle('onload');
      }, 500)
    })
  })
};

/**
 * 普通的ajax post请求
 *
 * @param {Object} formData  需要发送参数
 * @param {String} url 调用接口
 * @param {Object} config 配置
 * @returns 科里化后的call方法
 */
const normalCallPost = (url, formData) => {
  return call(post, url, formData);
};

const normalCallPostForm = (url, formData) => {
  return call(postForm, url, formData);
};


/**
 * 普通的ajax get请求
 *
 * @param {Object} formData  需要发送参数
 * @param {String} url 调用接口
 * @param {Object} config 配置
 * @returns 科里化后的call方法
 */
const normalCallGet = (url, formData, config) => {
  return call(get, url, formData, config);
};

/**
 * 使用队列的ajax请求，后自动cancel前一个请求
 *
 * @param {Object} formData  需要发送参数
 * @param {String} url 调用接口
 * @returns  科里化后的call方法
 */
const queueCall = (url, formData, config) => {
  return call(queue, url, formData, config);
};

/**
 * 获取设备操作系统
 *
 * @returns {string} os 操作系统
 */
const getOS = () => {
  let os = '';
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if(isAndroid) {
    os = 'android';
  }else if(isIOS) {
    os = 'iOS';
  }else{
    os = 'other'
  }
  return os;
}


const Prototype = function() {};

Prototype.install = (Vue, options) => {
  Vue.prototype.$queue = queueCall; // {function} post请求队列
  Vue.prototype.$type = type; // {function} 获取js对象类型
  Vue.prototype.$query = query; // {function} 获取url的query参数
  Vue.prototype.$post = normalCallPost; // {function} ajax post
  Vue.prototype.$postform = normalCallPostForm; // {function} ajax post
  Vue.prototype.$get = normalCallGet; // {function} ajax get
  Vue.prototype.$os = getOS(); // {string} 当前操作系统
  Vue.prototype.$baseApi = baseApi;
}

export default Prototype;



// WEBPACK FOOTER //
// ./src/assets/utils/index.js